import { MIS_CHANGE_REQUEST } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../resources/serviceURLs';

/**
 * Builds the base URL for the Change Request MIS API.
 * Used by TableUtility's generalSettings.baseURL.
 */
export const getChangeRequestMISBaseURL = () => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${MIS_CHANGE_REQUEST}`;
  }

  return `${baseUrl}:${servicePort}${serviceURL}/api${MIS_CHANGE_REQUEST}`;
};
